module.exports = __webpack_public_path__ + "img/hidden-password.3484aeae.svg";